<template>
    <dialog-modal :show="post" @close="close">

        <template #title>
            Are you sure?
        </template>

        <template #content>
            <div class="flex flex-col lg:flex-row items-center">
                <div class="w-full sm:w-1/2">
                    <div class="rounded-md overflow-hidden aspect-w-10 aspect-h-7" v-html="postThumb"></div>
                </div>
                <div class="text-base text-gray-600 m-3">{{ postTitle }}</div>
            </div>
        </template>

        <template #footer>

            <div class="flex flex-row-reverse">
                <danger-button class="ml-4" @click.native="destroy">
                    Archive
                </danger-button>

                <secondary-button :focus="!!post" @click.native="close">
                    Nevermind
                </secondary-button>
            </div>

        </template>

    </dialog-modal>
</template>

<script>

import DialogModal from '@/Jetstream/DialogModal';
import SecondaryButton from '@/Jetstream/SecondaryButton';
import DangerButton from '@/Jetstream/DangerButton';

export default {

    name: "DeletePostModal",
    components: {DangerButton, SecondaryButton, DialogModal},

    props: {
        post: {
            default: null,
            type: Object
        }
    },

    computed: {
        postThumb(){
            if(!this.post) return null;
            return this.post.thumbs[0];
        },

        postTitle(){
            if(!this.post) return null;
            return this.post.title;
        }
    },

    data() {
        return {
            form: this.$inertia.form({
                _method: 'POST',
            }),
        }
    },

    methods: {
        destroy(){
            this.close();
            this.form.delete(this.route('posts.destroy', {post: this.post}), {
                onFinish: () => this.$emit('update:post', null)
            })
        },

        close() {
            this.$emit('update:post', null);
        }
    },

}

</script>
